import React from 'react';
import { FaPhoneAlt, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './LetUsTalk.css';

const LetUsTalk = () => {
    return (
        <div className="talk-wrapper">
            <h2>LET US TALK</h2>
            <p>You can reach out to us with any of the below contacting options to discuss the project.</p>
            <div className="talk-grid">
                <div className="talk-card">
                    <div className="talk-icon">
                        <i className="fas fa-mobile-alt"></i>
                    </div>
                    <h4>GIVE US A CALL</h4>
                    <a href="tel:+918490957541">
                        <p> +91-8490957541</p>
                    </a>
                </div>
                <div className="talk-card">
                    <div className="talk-icon">
                        <FaEnvelope />
                    </div>
                    <h4>WRITE TO US</h4>
                    <a href="mailto:info@aptechsolution.com" target="_blank" rel="noopener noreferrer">
                        <p>info@aptechsolution.com</p>
                    </a>

                </div>
                <div className="talk-card">
                    <div className="talk-icon">
                        <FaWhatsapp />
                    </div>
                    <h4>CHAT WITH US</h4>
                    <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                        <p>Start Chat</p>
                    </a>

                </div>
                <div className="talk-card">
                    <div className="talk-icon">
                        <FaPhoneAlt />
                    </div>
                    <h4>GET A CALL BACK</h4>
                    <Link to="/contact" state={{ scrollTo: "form" }}>
                        <p>Leave your detail</p>
                    </Link>
                  
                   
                </div>
            </div>
        </div>
    );
};

export default LetUsTalk;
